// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'
import { get } from 'church-theme-library/utilities/objects'

// Redux:
import { getSabbathSchoolData } from 'church-theme-library/redux/actions/site'

class ThisWeek extends React.Component {
	componentDidMount() {
		this.props.dispatch( getSabbathSchoolData() )
	}

	componentDidUpdate( prevProps ) {
		const { locale, dispatch } = this.props

		if ( locale != prevProps.locale ) {
			dispatch( getSabbathSchoolData() )
		}
	}

	render() {
		let { contentId, sectionId, type, data, translate, sabbathSchoolThisWeek, preacherThisWeek } = this.props
		let mapCenter

		if ( siteData.location_lat && siteData.location_lng ) {
			mapCenter = {
				lat: parseFloat( siteData.location_lat ),
				lng: parseFloat( siteData.location_lng )
			}
		}

		if ( ! sabbathSchoolThisWeek ) {
			sabbathSchoolThisWeek = {
				url: '',
				lesson: '',
				quarter: '',
				image: {
					full: ''
				}
			}
		}

		if ( ! preacherThisWeek ) {
			preacherThisWeek = {
				name: '',
				sermon_title: '',
				sermon_image: ''
			}
		}

		return [
			<div className="section-this-week-header" key="section-this-week-header">
				<Editable
					element="h2"
					id={ contentId }
					sectionId={ sectionId }
					sectionType={ data.type }
					sectionDataId="heading"
					content={ data.heading }
				/>
			</div>,

			<div className="section-this-week" key="section-this-week">
				<div className="-inner">
					<div className="-content">
						<div className="-this-week">
							{ sabbathSchoolThisWeek &&
								<div className="-ss">
									<div className="-heading">
										<Editable
											element="h3"
											id={ contentId }
											sectionId={ sectionId }
											sectionType={ data.type }
											sectionDataId="ss_heading"
											content={ data.ss_heading }
										/>

										<Editable
											element="p"
											id={ contentId }
											sectionId={ sectionId }
											sectionType={ data.type }
											sectionDataId="ss_sub_heading"
											content={ data.ss_sub_heading }
										/>
									</div>

									<div className="-info">
										<div className="-info-text">
											<p className="-topic-pre">{ translate( 'Lesson topic' ) }</p>
											<h3>{ get( ['lesson', 'title'] )( sabbathSchoolThisWeek ) }</h3>

											<p className="-quarter" dangerouslySetInnerHTML={ { __html: get( ['quarter', 'title'] )( sabbathSchoolThisWeek ) } } />

											<p className="-link">
												<a href={ sabbathSchoolThisWeek.url_today } target="_blank" rel="noopener">{ translate( 'Read online' ) }</a>
											</p>
										</div>

										<div className="-image">
											<img src={ get( ['image', 'url'] )( sabbathSchoolThisWeek ) } alt={ get( ['lesson', 'title'] )( sabbathSchoolThisWeek ) } />
										</div>
									</div>
								</div>
							}

							<div className="-main-service">
								<div className="-heading">
									<Editable
										element="h3"
										id={ contentId }
										sectionId={ sectionId }
										sectionType={ data.type }
										sectionDataId="main_service_heading"
										content={ data.main_service_heading }
									/>

									<Editable
										element="p"
										id={ contentId }
										sectionId={ sectionId }
										sectionType={ data.type }
										sectionDataId="main_service_sub_heading"
										content={ data.main_service_sub_heading }
									/>
								</div>

								<Editable id="set_preachers" className="-info">
									{ ( preacherThisWeek.sermon_image && preacherThisWeek.sermon_image.url ) &&
										<div className="-image">
											<Image
												thumb={ preacherThisWeek.sermon_image.thumb }
												thumbWebp={ preacherThisWeek.sermon_image.thumb_webp }
												url={ preacherThisWeek.sermon_image.url }
												srcset={ preacherThisWeek.sermon_image.srcset }
												srcsetWebp={ preacherThisWeek.sermon_image.srcset_webp }
												sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
												alt={ preacherThisWeek.sermon_title }
												focalPoint={ preacherThisWeek.sermon_image.focal_point }
												width={ preacherThisWeek.sermon_image.width }
												height={ preacherThisWeek.sermon_image.height }
												aspectRatio={ preacherThisWeek.sermon_image.aspect_ratio }
											/>
										</div>
									}

									{ ( preacherThisWeek.name || preacherThisWeek.sermon_title ) &&
										<div className="-info-text">
											{ preacherThisWeek.name &&
												<p>{ preacherThisWeek.name }</p>
											}

											{ preacherThisWeek.sermon_title &&
												<h3>{ preacherThisWeek.sermon_title }</h3>
											}
										</div>
									}
								</Editable>
							</div>
						</div>
					</div>
				</div>
			</div>
		]
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		locale: state.site.locale,
		sabbathSchoolThisWeek: state.site.sabbathSchoolThisWeek,
		preacherThisWeek: state.site.preacherThisWeek
	}
}

export default localize(
	connect( mapStateToProps )( ThisWeek )
)
